import React, { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';

// props come from the DataGrid that uses this filter
const RangeFilter = (props) => {
    // console.log('props here', props)
    const { item, applyValue, focusElementRef = null } = props;
    const [filterValue, setFilterValue] = useState([null, null]);

    const preventNegativeNumbers = (value) => value < 0 ? '0' : value;

    const updateFilterValue = (lowerBound, upperBound) => {
        applyValue({ ...item, value: [lowerBound, upperBound] });
        setFilterValue([lowerBound, upperBound]);
    };

    const handleLowerBoundFilterChange = (event) => {
        const newLowerBound = event.target.value;
        updateFilterValue(preventNegativeNumbers(newLowerBound), filterValue[1]);
    };
    
    const handleUpperBoundFilterChange = (event) => {
        const newUpperBound = event.target.value;
        updateFilterValue(filterValue[0], preventNegativeNumbers(newUpperBound));
    };

    useEffect(() => {
        const { item: { value = [] } } = props;
        setFilterValue(value);
    }, []);

    return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'end',
            }}
        >
            <TextField
                name="lower-bound-input"
                placeholder="0"
                label="From"
                variant="standard"
                value={filterValue[0]}
                onChange={handleLowerBoundFilterChange}
                type="number"
                inputRef={focusElementRef}
                sx={{ mr: "5px" }}
                onWheel={(e) => e.target.blur()}
            />
            <TextField
                name="upper-bound-input"
                placeholder="0"
                label="To"
                variant="standard"
                value={filterValue[1]}
                onChange={handleUpperBoundFilterChange}
                type="number"
                onWheel={(e) => e.target.blur()}
            />
        </Box>
    );
};

// Get initializer for RangeFilter
export const getRangeFilterOperator = ({
    label = 'Between',
    value = 'between',
    getApplyFilterFn = () => { }, // this comes from MUI docs, honestly idk what it is used for
    InputComponentProps = {}
}) => {
    return [{
        label,
        value,
        getApplyFilterFn,
        InputComponent: RangeFilter,
        InputComponentProps
    }];
};

export default getRangeFilterOperator;
